/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class MinMaxScore
    {
        min: number;
        max: number;

        constructor( min: number, max: number )
        {
            this.min = min;
            this.max = max;
        }
    }

    export class SatScores 
    {
        difficulty: string;
        toolTipHeader: string = "Find colleges where your SAT scores are similar to recently admitted students.";
        selectedReading: string;
        selectedMath: string;
        selectedWriting: string;
        selected: boolean = false;

        scoreRanges = [{ type: "Score", scoreRange: new MinMaxScore( 0, 0 ) },
            { type: "200-400", scoreRange: new MinMaxScore( 200, 400 ) },
            { type: "410-470", scoreRange: new MinMaxScore( 410, 470 ) },
            { type: "480-530", scoreRange: new MinMaxScore( 480, 530 ) },
            { type: "540-600", scoreRange: new MinMaxScore( 540, 600 ) },
            { type: "610-800", scoreRange: new MinMaxScore( 610, 800 ) }];

        typeCbsMath = [{ type: "Score", isChecked: false },
            { type: "200-400", isChecked: false },
            { type: "410-470", isChecked: false },
            { type: "480-530", isChecked: false },
            { type: "540-600", isChecked: false },
            { type: "610-800", isChecked: false }];

        typeCbsWriting = [{ type: "Score", isChecked: false },
            { type: "200-400", isChecked: false },
            { type: "410-470", isChecked: false },
            { type: "480-530", isChecked: false },
            { type: "540-600", isChecked: false },
            { type: "610-800", isChecked: false }];


        constructor()
        {
            this.selectedReading = this.scoreRanges[0].type;
            this.selectedMath = this.scoreRanges[0].type;
            this.selectedWriting = this.scoreRanges[0].type;
        }
        public reset( filterToRemove: string )
        {
            if ( filterToRemove.indexOf( "SAT Reading" ) >= 0 )
                this.resetReading();
            else if ( filterToRemove.indexOf( "SAT Math" ) >= 0 )
                this.resetMath();
            else if ( filterToRemove.indexOf( "SAT Writing" ) >= 0 )
                this.resetWriting();
        }
        public resetReading()
        {
            this.selectedReading = this.scoreRanges[0].type;
            this.checkSelected();
        }

        public resetMath()
        {
            this.selectedMath = this.scoreRanges[0].type;
            this.checkSelected();
        }

        public resetWriting()
        {
            this.selectedWriting = this.scoreRanges[0].type;
            this.checkSelected();
        }

        private checkSelected()
        {
            if ( this.selectedReading !== "Score" || this.selectedMath !== "Score" || this.selectedWriting !== "Score" )
                this.selected = true;
            else
                this.selected = false;
        }
    }
} 